import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../hooks/useLanguage';
export function Fleet() {
  const {
    language
  } = useLanguage();
  const fleetCards = [{
    en: {
      title: 'Premium Van',
      micro: 'Ideal for families and small groups. Spacious, comfortable and fully equipped.'
    },
    es: {
      title: 'Furgoneta premium',
      micro: 'Ideal para familias y grupos pequeños. Amplia, cómoda y totalmente equipada.'
    },
    image: 'https://cdn.magicpatterns.com/uploads/7LRxjsUskUury7XMujTZCz/Uitvaartbus-nederland-volgbus-e1612164962756.png',
    alt: 'Mercedes V-Class premium van for transfers in Ibiza'
  }, {
    en: {
      title: 'Executive Vehicle',
      micro: 'Perfect for couples and business travellers. Elegant and discreet.'
    },
    es: {
      title: 'Vehículo ejecutivo',
      micro: 'Perfecto para parejas y viajeros de negocios. Elegante y discreto.'
    },
    image: 'https://cdn.magicpatterns.com/uploads/9aJngwT1i3Qs9x3rhKiqKY/maybachh.jpg',
    alt: 'Mercedes executive sedan for private transport in Ibiza'
  }, {
    en: {
      title: 'Group Travel Option',
      micro: 'For larger groups up to 16 passengers. Practical and reliable.'
    },
    es: {
      title: 'Opción para grupos',
      micro: 'Para grupos grandes de hasta 16 pasajeros. Práctico y fiable.'
    },
    image: 'https://cdn.magicpatterns.com/uploads/7MVpjgot7kbRSYjZwzb41A/sprinter-400x210.jpg',
    alt: 'Mercedes Sprinter for group transfers in Ibiza'
  }];
  const content = {
    en: {
      title: 'Vehicles for airport transfers, villa pickups and private transport',
      text: 'Our vehicles are selected to offer comfortable, practical and reliable transport in Ibiza. Ideal for airport transfers, hotel pickups, villa transport, group travel and premium journeys around the island.'
    },
    es: {
      title: 'Vehículos para aeropuerto, villas y transporte privado',
      text: 'Nuestros vehículos están pensados para ofrecer un transporte cómodo, práctico y fiable en Ibiza. Ideales para traslados de aeropuerto, recogidas en hoteles, villas, desplazamientos en grupo y trayectos premium por la isla.'
    }
  };
  const {
    title,
    text
  } = content[language];
  return <section id="fleet" className="py-10 md:py-16 bg-white" data-id="element-46">
      <div className="mx-auto max-w-7xl px-5" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5
      }} className="text-center max-w-3xl mx-auto mb-8 md:mb-10" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-heading text-navy mb-4" data-id="element-49">
            {title}
          </h2>
          <div className="w-12 h-px bg-gold-subtle/50 mx-auto mb-5" data-id="element-50" />
          <p className="text-slate leading-relaxed" data-id="element-51">{text}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10" data-id="element-52">
          {fleetCards.map((card, index) => {
          const cardContent = language === 'en' ? card.en : card.es;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="flex flex-col items-center text-center" data-id="element-53">
                <div className="w-full aspect-[16/9] flex items-center justify-center px-4 mb-4 md:mb-6" data-id="element-54">
                  <img src={card.image} alt={card.alt} className="w-full h-full object-contain" data-id="element-55" />
                </div>
                <h3 className="text-lg font-heading text-navy mb-2" data-id="element-56">
                  {cardContent.title}
                </h3>
                <p className="text-slate/80 text-sm max-w-[260px] leading-relaxed" data-id="element-57">
                  {cardContent.micro}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}